import { useEffect, useRef, useState } from 'react';

export function useHoverMenu(closeDelayMs = 200) {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const menuPaperRef = useRef<HTMLDivElement>(null);
  const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearCloseTimer = () => {
    if (closeTimer.current !== null) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const closeMenu = () => {
    clearCloseTimer();
    setIsOpen(false);
  };

  const containsPointer = (target: Node) =>
    Boolean(
      rootRef.current?.contains(target) ||
        menuPaperRef.current?.contains(target)
    );

  useEffect(() => {
    if (!isOpen) return;

    const onPointerMove = ({ target }: PointerEvent) => {
      if (containsPointer(target as Node)) {
        clearCloseTimer();
        return;
      }
      clearCloseTimer();
      closeTimer.current = setTimeout(() => {
        clearCloseTimer();
        setIsOpen(false);
      }, closeDelayMs);
    };

    document.addEventListener('pointermove', onPointerMove);
    return () => {
      document.removeEventListener('pointermove', onPointerMove);
      clearCloseTimer();
    };
  }, [isOpen, closeDelayMs]);

  return {
    isOpen,
    rootRef,
    menuPaperRef,
    closeMenu,
    rootProps: {
      ref: rootRef,
      onMouseEnter: () => {
        clearCloseTimer();
        setIsOpen(true);
      },
    },
  };
}
